export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxJlkc_SjTjQJElti5.a6dbca4b.woff2";